import React, { createContext, ReactNode } from 'react';
import { ProfileResponse } from '@/api/profile';

interface ProfileContextType {
  profile: ProfileResponse | null;
  setProfile: React.Dispatch<React.SetStateAction<ProfileResponse | null>>;
}

// eslint-disable-next-line react-refresh/only-export-components
export const ProfileContext = createContext<ProfileContextType | undefined>(
  undefined
);

export const ProfileProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [profile, setProfile] = React.useState<ProfileResponse | null>(null);
  return (
    <ProfileContext.Provider value={{ profile, setProfile }}>
      {children}
    </ProfileContext.Provider>
  );
};
